export const FR = "fr";
export const EN = "en";
